import { AsyncState, createAsyncStateReducer } from "react-async-stateful";

import * as LeaderboardsActions from "./Leaderboards.action";

import * as ReduxUtils from "../../lib/util/ReduxUtils";
import { LeaderboardData } from "../../lib/types/LeaderboardTypes";

export interface LeaderboardReducerState {
	leaderboards: AsyncState<{
		[groupName: string]: {
			active: LeaderboardData[];
			complete: LeaderboardData[];
		};
	}>;
}

const initialState: LeaderboardReducerState = {
	leaderboards: AsyncState.create({ __group: { active: [], complete: [] } }),
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<LeaderboardReducerState>({
		leaderboards: LeaderboardsActions.getGroupLeaderboards.type,
	}),
]);
